import { Address } from 'types'
import { ApiV1Response, http } from '../http'

export async function getEarnsLuckyList<
  T extends ApiV1Response<Address[]>,
>(): Promise<T> {
  return http.get(`/earns/luck/list`).then((r) => r.data)
}
